import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFailFull2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Fail_full2"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8}
      fill="var(--color-content-status-danger-secondary)"
      fillOpacity={0.25}
    />
    <path
      fill="var(--color-content-status-danger-secondary)"
      d="M11 13.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0M9.2 10.4a.8.8 0 0 0 1.6 0V6a.8.8 0 0 0-1.6 0z"
    />
  </svg>
);
export default SvgFailFull2;
